var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHouse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u5F62\u72B6") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "20221024\\u95E8\\u5E97\\u5206\\u6790\\uFF08\\u5934\\u90E8\\u6709\\u6539\\u7248\\uFF09",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7ECF\\u8425\\u5206\\u6790-\\u7EFC\\u5408\\u5206\\u6790",
    transform: "translate(-651.000000, -151.000000)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-43",
    transform: "translate(627.000000, 88.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-27\\u5907\\u4EFD-2",
    transform: "translate(5.000000, 53.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4",
    transform: "translate(19.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4",
    transform: "translate(0.000000, 1.000282)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.8158536,10.5002695 C19.2954736,10.5002695 19.6842797,10.8919991 19.6842797,11.3752256 L19.6842797,18.9581961 C19.6842797,20.0839023 18.775223,20.9997177 17.6578928,20.9997177 L14.1842651,20.9997177 C13.0669604,20.9997177 12.1579547,20.0838767 12.1579547,18.9581961 L12.1579547,15.1667109 L9.84213497,15.1667109 L9.84213497,18.9582218 C9.84213497,20.0839023 8.93312925,20.9997177 7.81582455,20.9997177 L4.3421459,20.9997177 C3.2248412,20.9997177 2.31583548,20.0839023 2.31583548,18.9582218 L2.31583548,11.3752256 C2.31583548,10.8919991 2.70464152,10.5002695 3.18426151,10.5002695 C3.6638815,10.5002695 4.05268754,10.8919991 4.05268754,11.3752256 L4.05268754,18.9581961 C4.05268754,19.1189893 4.18255279,19.2497797 4.34217137,19.2497797 L7.81582455,19.2497797 C7.97544316,19.2497797 8.10530838,19.1189636 8.10530838,18.9581961 L8.10530838,14.2917547 C8.10530838,13.8085282 8.49411443,13.4167985 8.97373442,13.4167985 L13.0264062,13.4167985 C13.5060262,13.4167985 13.8948322,13.8085282 13.8948322,14.2917547 L13.8948322,18.9581961 C13.8948322,19.1189893 14.0246975,19.2497797 14.1842906,19.2497797 L17.6579183,19.2497797 C17.8175624,19.2497797 17.9474276,19.1189636 17.9474276,18.9581961 L17.9474276,11.3752256 C17.9474276,10.8919991 18.3362336,10.5002695 18.8158536,10.5002695 Z M10.999841,0 C11.525594,0 12.0218739,0.199522144 12.3973062,0.561788025 L21.732472,9.57583062 C22.0787369,9.91017265 22.0904039,10.4640301 21.7585317,10.8129243 C21.426685,11.1617672 20.8769612,11.1735733 20.5306709,10.8392056 L11.1957343,1.82536832 C11.0915466,1.72481161 10.908594,1.72460631 10.8044573,1.82521432 L1.46931688,10.8392056 C1.3010372,11.0017183 1.08461213,11.082468 0.868543689,11.082468 C0.640069522,11.082468 0.412028402,10.9922222 0.24145609,10.8129243 C-0.0904160917,10.4640557 -0.0787236164,9.91019831 0.267541224,9.57583062 L9.60252875,0.561993331 C9.97760443,0.199650451 10.4738843,0 10.999841,0 Z",
    id: "\\u5F62\\u72B6\\u7ED3\\u5408"
  })))))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouse);
export default __webpack_public_path__ + "static/media/house.02601f82056a844419bbe038f6e9091f.svg";
export { ForwardRef as ReactComponent };